import { Component, Input, OnInit } from '@angular/core';
/**
 * Componente que muestra un título de alerta dentro de un formulario.
 */
@Component({
    selector: 'title-form-alert',
    templateUrl: './title-form-alert.component.html',
    styleUrls: ['./title-form-alert.component.scss'],
    standalone: false
})
export class TitleFormAlertComponent implements OnInit {

  /** Título de la alerta */
  @Input() title: string = '';
  
  /** Indica si el formulario es válido */
  @Input() valid: boolean = false;
  
  /** Indica si se debe mostrar un ícono en la alerta */
  @Input() showIcon: boolean = false;
  
  /** Subtítulo de la alerta */
  @Input() subtitle: string = '';
  constructor() { }

  ngOnInit() {
  }

}
